import React from "react";
import { useView } from "../contexts/ViewContext";
import NavSidebarLegacy from "./NavSidebarLegacy";
import NavSidebarGrouped, {
  buildGroups,
  StatusBadge,
  ChevronDownIcon,
} from "./NavSidebarGrouped";

// Re-export shared building blocks so consumers like AdminHeader's mobile menu
// can keep importing from a single entry point.
export { buildGroups, StatusBadge, ChevronDownIcon };

/**
 * Sidebar switcher.
 *
 * Renders the new grouped sidebar when the `new_menu` feature flag is enabled
 * for the current project. Otherwise renders the legacy flat icon-only sidebar.
 *
 * Default: every project uses the legacy sidebar until a Super Admin
 * explicitly toggles `new_menu` on for that project in Project Management.
 *
 * @param {string} activePage - works for both layouts; legacy maps short keys
 *                              ("events", "route", "competitive") to its old
 *                              long keys internally.
 */
export default function NavSidebar({ activePage }) {
  const { showNewMenu } = useView();

  if (showNewMenu) {
    return <NavSidebarGrouped activePage={activePage} />;
  }
  return <NavSidebarLegacy activePage={activePage} />;
}
